import { useState, useRef, useEffect } from "react";
import {
  HiOutlineCalculator,
  HiOutlineScale,
  HiOutlineBookmark,
  HiOutlineSave,
  HiCheck,
  HiOutlineTrendingUp,
  HiOutlineDotsHorizontal,
  HiOutlineTrendingDown,
  HiStar,
  HiOutlineStar,
  HiOutlineCog,
} from "react-icons/hi";
import Button from "../../../../../components/button/button";
import InputDropdown from "../../../../../components/inputs/inputDropdown/inputDropdown";
import Notification from "../../../../../components/notification/notification";
import "./precio.scss";
import Input from "../../../../../components/inputs/input/input";
import Modal from "../../../../../components/modal/modal";
import Popup from "../../../../../components/popup/popup";
import Tabs from "../../../../../components/tabs/tabs";

export default function Precio({ user, isV2 = false }) {
  const [modoComparativa, setModoComparativa] = useState(false);
  const [mostrarCalculosGuardados, setMostrarCalculosGuardados] =
    useState(false);
  const [calculosGuardados, setCalculosGuardados] = useState([]);

  const [calculoGuardado_A, setCalculoGuardado_A] = useState(false);
  const [calculoGuardado_B, setCalculoGuardado_B] = useState(false);
  const [hashCalculoActual_A, setHashCalculoActual_A] = useState(null);
  const [hashCalculoActual_B, setHashCalculoActual_B] = useState(null);
  const [activeTabFeedback, setActiveTabFeedback] = useState("precioReal");
  const [predictionData, setPredictionData] = useState(null);

  useEffect(() => {
    const guardados = localStorage.getItem("calculosGuardados");
    if (guardados) {
      setCalculosGuardados(JSON.parse(guardados));
    }
  }, []);

  const [selectedAcabado1_A, setSelectedAcabado1_A] = useState(null);
  const [selectedAcabado2_A, setSelectedAcabado2_A] = useState(null);
  const [selectedAcabado3_A, setSelectedAcabado3_A] = useState(null);
  const [selectedCategoria_A, setSelectedCategoria_A] = useState(null);
  const [selectedEstructura1_A, setSelectedEstructura1_A] = useState(null);
  const [selectedEstructura2_A, setSelectedEstructura2_A] = useState(null);
  const [selectedEstructura3_A, setSelectedEstructura3_A] = useState(null);
  const [selectedIluminacion_A, setSelectedIluminacion_A] = useState(null);
  const [selectedLocalizacion_A, setSelectedLocalizacion_A] = useState(null);
  const [selectedAncho_A, setSelectedAncho_A] = useState({ value: 0 });
  const [selectedLargo_A, setSelectedLargo_A] = useState({ value: 0 });
  const [selectedAlto_A, setSelectedAlto_A] = useState({ value: 0 });
  const [selectedDiametro_A, setSelectedDiametro_A] = useState({ value: 0 });
  const [selectedNivel1_A, setSelectedNivel1_A] = useState(null);
  const [selectedNivel2_A, setSelectedNivel2_A] = useState(null);
  const [selectedNivel3_A, setSelectedNivel3_A] = useState(null);
  const [precioCalculado_A, setPrecioCalculado_A] = useState(null);
  const [calculando_A, setCalculando_A] = useState(false);
  const [formKey_A, setFormKey_A] = useState(0);

  const [selectedAcabado1_B, setSelectedAcabado1_B] = useState(null);
  const [selectedAcabado2_B, setSelectedAcabado2_B] = useState(null);
  const [selectedAcabado3_B, setSelectedAcabado3_B] = useState(null);
  const [selectedCategoria_B, setSelectedCategoria_B] = useState(null);
  const [selectedEstructura1_B, setSelectedEstructura1_B] = useState(null);
  const [selectedEstructura2_B, setSelectedEstructura2_B] = useState(null);
  const [selectedEstructura3_B, setSelectedEstructura3_B] = useState(null);
  const [selectedIluminacion_B, setSelectedIluminacion_B] = useState(null);
  const [selectedLocalizacion_B, setSelectedLocalizacion_B] = useState(null);
  const [selectedAncho_B, setSelectedAncho_B] = useState({ value: 0 });
  const [selectedLargo_B, setSelectedLargo_B] = useState({ value: 0 });
  const [selectedAlto_B, setSelectedAlto_B] = useState({ value: 0 });
  const [selectedDiametro_B, setSelectedDiametro_B] = useState({ value: 0 });
  const [selectedNivel1_B, setSelectedNivel1_B] = useState(null);
  const [selectedNivel2_B, setSelectedNivel2_B] = useState(null);
  const [selectedNivel3_B, setSelectedNivel3_B] = useState(null);
  const [precioCalculado_B, setPrecioCalculado_B] = useState(null);
  const [calculando_B, setCalculando_B] = useState(false);
  const [formKey_B, setFormKey_B] = useState(0);

  // Estados para valoración A
  const [mostrarValoracion_A, setMostrarValoracion_A] = useState(false);
  const [precioReal_A, setPrecioReal_A] = useState("");
  const [puntuacion_A, setPuntuacion_A] = useState(0);
  const [comparacion_A, setComparacion_A] = useState("");
  const [comentarios_A, setComentarios_A] = useState("");
  const [valoracionGuardada_A, setValoracionGuardada_A] = useState(false);

  // Estados para valoración B
  const [mostrarValoracion_B, setMostrarValoracion_B] = useState(false);
  const [precioReal_B, setPrecioReal_B] = useState("");
  const [puntuacion_B, setPuntuacion_B] = useState(0);
  const [comparacion_B, setComparacion_B] = useState("");
  const [comentarios_B, setComentarios_B] = useState("");
  const [valoracionGuardada_B, setValoracionGuardada_B] = useState(false);

  // DEMO
  const [responseAverage, setResponseAverage] = useState("");

  const notificationRef = useRef();

  const generarHashCalculo = (estados) => {
    const datosCalculo = {
      categoria: estados.selectedCategoria?.value,
      localizacion: estados.selectedLocalizacion?.value,
      nivel1: estados.selectedNivel1?.value,
      nivel2: estados.selectedNivel2?.value,
      nivel3: estados.selectedNivel3?.value,
      ancho: estados.selectedAncho?.value,
      largo: estados.selectedLargo?.value,
      alto: estados.selectedAlto?.value,
      diametro: estados.selectedDiametro?.value,
      acabado1: estados.selectedAcabado1?.value,
      acabado2: estados.selectedAcabado2?.value,
      acabado3: estados.selectedAcabado3?.value,
      estructura1: estados.selectedEstructura1?.value,
      estructura2: estados.selectedEstructura2?.value,
      estructura3: estados.selectedEstructura3?.value,
      iluminacion: estados.selectedIluminacion?.value,
      precio: estados.precioCalculado,
    };

    return JSON.stringify(datosCalculo);
  };

  useEffect(() => {
    const estadosA = {
      selectedCategoria: selectedCategoria_A,
      selectedLocalizacion: selectedLocalizacion_A,
      selectedNivel1: selectedNivel1_A,
      selectedNivel2: selectedNivel2_A,
      selectedNivel3: selectedNivel3_A,
      selectedAncho: selectedAncho_A,
      selectedLargo: selectedLargo_A,
      selectedAlto: selectedAlto_A,
      selectedDiametro: selectedDiametro_A,
      selectedAcabado1: selectedAcabado1_A,
      selectedAcabado2: selectedAcabado2_A,
      selectedAcabado3: selectedAcabado3_A,
      selectedEstructura1: selectedEstructura1_A,
      selectedEstructura2: selectedEstructura2_A,
      selectedEstructura3: selectedEstructura3_A,
      selectedIluminacion: selectedIluminacion_A,
      precioCalculado: precioCalculado_A,
    };

    const nuevoHash = generarHashCalculo(estadosA);
    if (hashCalculoActual_A && nuevoHash !== hashCalculoActual_A) {
      setCalculoGuardado_A(false);
    }
  }, [
    selectedCategoria_A,
    selectedLocalizacion_A,
    selectedNivel1_A,
    selectedNivel2_A,
    selectedNivel3_A,
    selectedAncho_A,
    selectedLargo_A,
    selectedAlto_A,
    selectedDiametro_A,
    selectedAcabado1_A,
    selectedAcabado2_A,
    selectedAcabado3_A,
    selectedEstructura1_A,
    selectedEstructura2_A,
    selectedEstructura3_A,
    selectedIluminacion_A,
    precioCalculado_A,
    hashCalculoActual_A,
  ]);

  useEffect(() => {
    const estadosB = {
      selectedCategoria: selectedCategoria_B,
      selectedLocalizacion: selectedLocalizacion_B,
      selectedNivel1: selectedNivel1_B,
      selectedNivel2: selectedNivel2_B,
      selectedNivel3: selectedNivel3_B,
      selectedAncho: selectedAncho_B,
      selectedLargo: selectedLargo_B,
      selectedAlto: selectedAlto_B,
      selectedDiametro: selectedDiametro_B,
      selectedAcabado1: selectedAcabado1_B,
      selectedAcabado2: selectedAcabado2_B,
      selectedAcabado3: selectedAcabado3_B,
      selectedEstructura1: selectedEstructura1_B,
      selectedEstructura2: selectedEstructura2_B,
      selectedEstructura3: selectedEstructura3_B,
      selectedIluminacion: selectedIluminacion_B,
      precioCalculado: precioCalculado_B,
    };

    const nuevoHash = generarHashCalculo(estadosB);
    if (hashCalculoActual_B && nuevoHash !== hashCalculoActual_B) {
      setCalculoGuardado_B(false);
    }
  }, [
    selectedCategoria_B,
    selectedLocalizacion_B,
    selectedNivel1_B,
    selectedNivel2_B,
    selectedNivel3_B,
    selectedAncho_B,
    selectedLargo_B,
    selectedAlto_B,
    selectedDiametro_B,
    selectedAcabado1_B,
    selectedAcabado2_B,
    selectedAcabado3_B,
    selectedEstructura1_B,
    selectedEstructura2_B,
    selectedEstructura3_B,
    selectedIluminacion_B,
    precioCalculado_B,
    hashCalculoActual_B,
  ]);

  const nivel1Options = [
    { label: "Sin seleccionar", value: null },
    { label: "Mobiliario de Imagen ", value: 140 },
  ];

  const nivel2Options = [
    { label: "Sin seleccionar", value: null },
    { label: "Cobro", value: 1 },
    { label: "Probadores", value: 2 },
    { label: "Perimetral", value: 3 },
    { label: "Central", value: 4 },
    { label: "Zonas Comunes", value: 5 },
    { label: "Elementos Especiales", value: 6 },
    { label: "Dotación", value: 7 },
    { label: "Elementos Gráficos", value: 8 },
  ];

  const nivel3Options = [
    { label: "Sin seleccionar", value: null },
    { label: "Banco", value: 1 },
    { label: "Colgador", value: 2 },
    { label: "Decoración", value: 3 },
    { label: "Dotación", value: 4 },
    { label: "Espejo", value: 5 },
    { label: "Jaula", value: 6 },
    { label: "Tarima", value: 7 },
    { label: "Zapatero", value: 8 },
    { label: "Complementos", value: 10 },
    { label: "Estantería", value: 11 },
    { label: "Rótulos", value: 14 },
    { label: "Cajas", value: 15 },
    { label: "Murete", value: 17 },
    { label: "Barras", value: 18 },
    { label: "Panelado", value: 20 },
    { label: "Mesa", value: 22 },
    { label: "Cabina", value: 23 },
    { label: "Mostrador", value: 24 },
    { label: "Armario de Caja", value: 25 },
    { label: "Módulo", value: 26 },
    { label: "Pantallas", value: 28 },
    { label: "Estantes", value: 30 },
    { label: "Bandejas", value: 33 },
    { label: "Pinchos", value: 34 },
    { label: "Displays", value: 35 },
    { label: "Directorios", value: 36 },
    { label: "Vinilos", value: 37 },
  ];

  const acabado1Options = [
    { label: "Sin seleccionar", value: null },
    { label: "Avida", value: 1 },
    { label: "Madera", value: 2 },
    { label: "Azulejo", value: 3 },
    { label: "OSBCemento", value: 4 },
    { label: "FenixBeige", value: 5 },
    { label: "FormicaIron", value: 6 },
    { label: "LacadoGris", value: 7 },
    { label: "AzulejoGris", value: 8 },
    { label: "AceroGalvanizado", value: 9 },
    { label: "Granito", value: 10 },
    { label: "Piedra", value: 11 },
    { label: "AzulejoBlanco", value: 12 },
    { label: "AzulejoVerde", value: 13 },
    { label: "LacadoAmarillo", value: 14 },
    { label: "LacadoBOHVerde", value: 15 },
    { label: "PinturaGalvanizada", value: 16 },
    { label: "LacadoBlanco", value: 17 },
    { label: "ViniloNegro", value: 18 },
    { label: "ViniloGris", value: 19 },
    { label: "ViniloBlanco", value: 20 },
    { label: "AceroCarbono", value: 21 },
    { label: "MetacrilatoBlancoOpal", value: 22 },
    { label: "Pintura Marron", value: 23 },
    { label: "Pintura Naranja", value: 24 },
    { label: "MetacrilatoNaranja", value: 25 },
    { label: "PinturaTienda", value: 26 },
    { label: "Led/PantallaLed", value: 27 },
    { label: "MetacrilatoBlanco", value: 28 },
    { label: "MetacrilatoTransparente", value: 29 },
    { label: "AceroCincado", value: 30 },
    { label: "AceroInox", value: 31 },
    { label: "AceroLacado", value: 32 },
    { label: "Acero", value: 33 },
    { label: "LacadoBeige", value: 34 },
    { label: "LacadoVerde", value: 35 },
    { label: "AceroPulverit", value: 36 },
    { label: "AceroInoxBrillo", value: 37 },
    { label: "Color", value: 38 },
    { label: "MetacrilatoRosa", value: 39 },
    { label: "HormigonW", value: 40 },
    { label: "CauchoReciclado", value: 41 },
    { label: "CauchoTarkett", value: 42 },
    { label: "PlasticoReciclado", value: 43 },
    { label: "MetacrilatoAzul", value: 44 },
    { label: "MetacrilatoAmarillo", value: 45 },
    { label: "KrionRosa", value: 46 },
    { label: "AcrilicoRosa", value: 47 },
    { label: "MaderaArce", value: 48 },
    { label: "Metacrilato", value: 49 },
    { label: "AluminioLaminado", value: 50 },
    { label: "KrionMarfil", value: 51 },
    { label: "CauchoMelamina", value: 52 },
    { label: "RAL9001", value: 53 },
    { label: "TarkettRosa", value: 55 },
    { label: "LacadoKrionRosa", value: 56 },
    { label: "MorteroG", value: 57 },
    { label: "MorteroR", value: 58 },
    { label: "LacadoBOHGris", value: 61 },
    { label: "MaderaRoble", value: 62 },
    { label: "LinoBeige", value: 63 },
    { label: "HormigonG", value: 64 },
    { label: "MaderaChopo", value: 65 },
    { label: "Policarbonato", value: 66 },
    { label: "Espejo", value: 67 },
    { label: "PantallaLed", value: 68 },
    { label: "RevestimientoConchas", value: 69 },
    { label: "LacadoNegroBrillante", value: 70 },
    { label: "CeramicoWhite", value: 71 },
    { label: "ViniloGrisMoteado", value: 72 },
    { label: "Tarkett", value: 73 },
    { label: "OSB", value: 74 },
    { label: "Vinilo", value: 75 },
    { label: "Pantalla", value: 76 },
    { label: "Abedul", value: 77 },
    { label: "LacadoAzulejoGris", value: 78 },
    { label: "LacadoAzulejoVerde", value: 79 },
    { label: "AzulejoAzul", value: 80 },
    { label: "FenixGris", value: 81 },
    { label: "AceroVibrado", value: 82 },
    { label: "Osb", value: 83 },
    { label: "PVCBeige", value: 84 },
    { label: "Pintura", value: 85 },
    { label: "AceroLacadoGris", value: 86 },
    { label: "AzulejoBeige", value: 87 },
    { label: "Alluslate", value: 88 },
    { label: "MaderaHaya", value: 89 },
    { label: "Tela", value: 90 },
    { label: "TelaAmarilla", value: 91 },
    { label: "TelaGris", value: 92 },
    { label: "PoliuretanoAmarillo", value: 93 },
    { label: "PoliuretanoAzul", value: 94 },
    { label: "PoliuretanoNaranja", value: 95 },
    { label: "PoliuretanoVerde", value: 96 },
    { label: "SLCrepaSilver", value: 98 },
    { label: "Verde BOH", value: 99 },
    { label: "Caucho", value: 100 },
    { label: "Polipropileno", value: 101 },
    { label: "Metaled", value: 102 },
    { label: "LightBlue4701", value: 103 },
    { label: "CauchoTarkett088", value: 104 },
    { label: "AceroInox+AR3174:AT3174AQ3174AAR3174:BZ3174", value: 105 },
    { label: "Tarkett999", value: 106 },
    { label: "TarkettSueloProbador", value: 107 },
    { label: "LacadoRal9010Mate", value: 108 },
    { label: "AluminioCepillado", value: 109 },
    { label: "AceroNegro", value: 110 },
    { label: "MaderaGlory", value: 111 },
    { label: "Aluminio", value: 112 },
    { label: "TarkettSuelo", value: 113 },
    { label: "LacadoNegro", value: 114 },
    { label: "LacadoGrisBrillo", value: 115 },
    { label: "Lacado Gris", value: 116 },
    { label: "Undora", value: 117 },
    { label: "AzulejoGrisOscuroBrillo", value: 118 },
    { label: "AzulejoVerdeBrilloIbiza", value: 119 },
    { label: "TarkettPlazza2Coral", value: 120 },
    { label: "LacadoGrisOscuroMate", value: 121 },
    { label: "LacadoVerdeMateIbiza", value: 122 },
    { label: "LacadoBlancoAzulejo", value: 123 },
    { label: "LacadoNCSS2500N", value: 124 },
    { label: "Arce", value: 126 },
  ];

  const categoriaOptions = [
    { label: "Sin seleccionar", value: null },
    { label: "Mobiliario", value: 1 },
    { label: "Modelos genericos", value: 2 },
  ];

  const acabado2Options = [
    { label: "Sin seleccionar", value: null },
    { label: "AceroGalvanizado", value: 2 },
    { label: "ViniloNegro", value: 3 },
    { label: "RevestimientoConchas", value: 4 },
    { label: "AceroInox", value: 5 },
    { label: "KrionMarfil", value: 6 },
    { label: "CorianRaffia", value: 7 },
    { label: "KrionVetro", value: 8 },
    { label: "LacadoBOHVerde", value: 9 },
    { label: "AceroCincado", value: 10 },
    { label: "AceroCarbono", value: 11 },
    { label: "Carbono", value: 12 },
    { label: "OSBCemento", value: 13 },
    { label: "Abedul", value: 14 },
    { label: "AluminioLaminado", value: 15 },
    { label: "CauchoReciclado", value: 16 },
    { label: "AcrilicoRosa", value: 17 },
    { label: "HormigonW", value: 18 },
    { label: "HormigonG", value: 19 },
    { label: "MaderaArce", value: 20 },
    { label: "FlexicelQuash", value: 21 },
    { label: "PantallaLed", value: 22 },
    { label: "Pandomo", value: 23 },
    { label: "Espejo", value: 24 },
    { label: "AceroLacado", value: 25 },
    { label: "LacadoAzul", value: 26 },
    { label: "MetacrilatoOpal", value: 27 },
    { label: "Led", value: 28 },
    { label: "Acero", value: 30 },
    { label: "LacadoAzulejoGris", value: 31 },
    { label: "LacadoAzulejoVerde", value: 32 },
    { label: "LacadoGris", value: 33 },
    { label: "Azulejo", value: 34 },
    { label: "Formica Iron", value: 35 },
    { label: "OSB", value: 36 },
    { label: "FenixBeige", value: 37 },
    { label: "FormicaIron", value: 38 },
    { label: "AzulejoGris", value: 39 },
    { label: "Osb", value: 40 },
    { label: "Piedra", value: 41 },
    { label: "AzulejoVerde", value: 42 },
    { label: "MaderaHaya", value: 43 },
    { label: "MorteroG", value: 44 },
    { label: "MaderaRoble", value: 45 },
    { label: "LacadoNegro", value: 46 },
    { label: "LacadoVerde", value: 47 },
    { label: "HomigonW", value: 48 },
    { label: "Metaled", value: 50 },
    { label: "Ral9005Brillo", value: 51 },
    { label: "NCS-S-2500-N", value: 52 },
    { label: "Tarket088", value: 53 },
    { label: "Tarkett080", value: 54 },
    { label: "Tarkett999", value: 55 },
    { label: "Ral9005", value: 56 },
    { label: "TarkettGlory", value: 57 },
    { label: "LacadoNCSS1502GMate", value: 58 },
    { label: "TarkettSuelo", value: 59 },
    { label: "TarketSuelo", value: 60 },
    { label: "LacadoGrisOscuroMate", value: 61 },
    { label: "LacadoVerdeMateIbiza", value: 62 },
    { label: "LacadoGrisBrillo", value: 63 },
    { label: "Arce", value: 65 },
  ];

  const acabado3Options = [
    { label: "Sin seleccionar", value: null },
    { label: "AceroGalvanizado", value: 2 },
    { label: "AcrilicoRosa", value: 3 },
    { label: "HormigonW", value: 4 },
    { label: "HormigonG", value: 6 },
    { label: "TelaRoja", value: 7 },
    { label: "Formica Iron", value: 8 },
    { label: "OSB", value: 9 },
    { label: "Azulejo", value: 10 },
    { label: "Policarbonato", value: 11 },
    { label: "Espuma", value: 12 },
    { label: "AceroInox", value: 13 },
    { label: "MaderaChopo", value: 14 },
    { label: "LacadoAmarillo", value: 15 },
    { label: "AzulejoBlanco", value: 16 },
    { label: "LacadoBeige", value: 17 },
    { label: "MetacrilatoViniloAcido", value: 18 },
    { label: "AluminioLaminado", value: 19 },
    { label: "LacadoBlanco", value: 21 },
    { label: "LacadoBlancoAzulejo", value: 22 },
  ];

  const estructura1Options = [
    { label: "Sin seleccionar", value: null },
    { label: "Madera", value: 1 },
    { label: "DM", value: 2 },
    { label: "Acero", value: 4 },
    { label: "Metacrilato", value: 5 },
    { label: "PVC", value: 6 },
    { label: "Aluminio", value: 7 },
    { label: "Krion", value: 8 },
    { label: "OSB", value: 9 },
    { label: "Hormigon", value: 10 },
    { label: "Textil", value: 12 },
    { label: "EspumaPoliuretano", value: 13 },
    { label: "AceroInox", value: 15 },
    { label: "Caucho", value: 16 },
    { label: "Polipropileno", value: 17 },
    { label: "Osb", value: 18 },
    { label: "MaderaGlory", value: 19 },
    { label: "Hierro", value: 20 },
    { label: "Undora", value: 21 },
  ];

  const estructura2Options = [
    { label: "Sin seleccionar", value: null },
    { label: "Acero", value: 2 },
    { label: "DM", value: 3 },
    { label: "Krion", value: 4 },
    { label: "Corian", value: 5 },
    { label: "Metacrilato", value: 6 },
    { label: "Hormigon", value: 7 },
    { label: "PVC", value: 9 },
    { label: "Madera", value: 10 },
  ];

  const estructura3Options = [
    { label: "Sin seleccionar", value: null },
    { label: "Acero", value: 1 },
    { label: "Metacrilato", value: 2 },
  ];

  const iluminacionOptions = [
    { label: "Sin seleccionar", value: null },
    { label: "1800K", value: 1 },
    { label: "180LEDS/m 3000K", value: 2 },
    { label: "5500K", value: 3 },
    { label: "240LEDS/m 3000K", value: 4 },
    { label: "300LEDS/m 3000K", value: 5 },
  ];

  const localizacionOptions = [
    { label: "Sin seleccionar", value: null },
    { label: "Cobro", value: 1 },
    { label: "Dotación", value: 2 },
    { label: "Elementos Gráficos", value: 3 },
    { label: "Mobiliario Central", value: 6 },
    { label: "Mobiliario Perimetral", value: 7 },
    { label: "Probadores", value: 9 },
    { label: "Zonas Comunes", value: 11 },
  ];

const nivelesMapping = [
  { nivel1: 140, nivel2: 3, nivel3: 2, label: "Mobiliario Perimetral Colgador" },
  { nivel1: 140, nivel2: 2, nivel3: 23, label: "Mobiliario Probadores Cabina" },
  { nivel1: 140, nivel2: 4, nivel3: 2, label: "Mobiliario Central Colgador" },
  { nivel1: 140, nivel2: 3, nivel3: 3, label: "Mobiliario Perimetral Decoración" },
  { nivel1: 140, nivel2: 3, nivel3: 20, label: "Mobiliario Perimetral Panelado" },
  { nivel1: 140, nivel2: 3, nivel3: 8, label: "Mobiliario Perimetral Zapatero" },
  { nivel1: 140, nivel2: 1, nivel3: 26, label: "Mobiliario Cobro Módulo" },
  { nivel1: 140, nivel2: 4, nivel3: 22, label: "Mobiliario Central Mesa" },
  { nivel1: 140, nivel2: 7, nivel3: 35, label: "Mobiliario Dotación Displays" },
  { nivel1: 140, nivel2: 3, nivel3: 5, label: "Mobiliario Perimetral Espejo" },
  { nivel1: 140, nivel2: 7, nivel3: 34, label: "Mobiliario Dotación Pinchos" },
  { nivel1: 140, nivel2: 3, nivel3: 10, label: "Mobiliario Perimetral Complementos" },
  { nivel1: 140, nivel2: 7, nivel3: 10, label: "Mobiliario Dotación Complementos" },
  { nivel1: 140, nivel2: 3, nivel3: 11, label: "Mobiliario Perimetral Estantería" },
];

const acabadoPrincipalV2 = [
  { label: "Sin acabado / En bruto", value: 10 },
  { label: "Pintura al agua básica", value: 11 },
  { label: "Lacado mate monocapa", value: 12 },
  { label: "Lacado mate bicapa", value: 13 },
  { label: "Lacado semibrillo", value: 14 },
  { label: "Lacado alto brillo", value: 15 },
  { label: "Lacado texturizado", value: 16 },
  { label: "Pintura metálica / perlada", value: 17 },

  { label: "Melamina estándar", value: 20 },
  { label: "Melamina extra mate", value: 21 },
  { label: "Laminado HPL estándar", value: 22 },
  { label: "Laminado HPL macizo autoportante", value: 23 },
  { label: "Vinilo PVC impreso", value: 24 },

  { label: "Chapa madera roble", value: 30 },
  { label: "Chapa madera haya", value: 31 },
  { label: "Chapa madera nogal", value: 32 },
  { label: "Chapa madera wengué", value: 33 },
  { label: "Chapa madera teca", value: 34 },

  { label: "Tela estándar", value: 40 },
  { label: "Tela premium", value: 41 },
  { label: "Tela técnica antimanchas", value: 42 },
  { label: "Polipiel / Cuero sintético", value: 43 },
  { label: "Cuero natural", value: 44 },
  { label: "Cuero ecológico", value: 45 },

  { label: "Microcemento", value: 50 },
  { label: "Mármol natural", value: 51 },
  { label: "Granito natural", value: 52 },
  { label: "Silestone / Cuarzo compacto", value: 53 },
  { label: "Vidrio templado lacado", value: 54 },
  { label: "Vidrio serigrafiado", value: 55 },
  { label: "Terrazo", value: 56 },
  { label: "Corcho", value: 57 },
  { label: "Arcilla", value: 58 },

  { label: "Acero lacado alto brillo", value: 60 },
  { label: "Latón cepillado", value: 61 },
  { label: "Cobre natural con pátina", value: 62 },
  { label: "Aluminio anodizado", value: 63 }
];

const acabadoSecundarioV2 = [
  { label: "Sin acabado secundario", value: 10 },

  { label: "Lacado mate", value: 11 },
  { label: "Lacado alto brillo", value: 12 },

  { label: "Melamina estándar", value: 20 },
  { label: "Melamina extra mate", value: 21 },
  { label: "Laminado HPL estándar", value: 22 },
  { label: "Laminado HPL macizo autoportante", value: 23 },
  { label: "Vinilo PVC impreso", value: 24 },

  { label: "Chapa madera roble", value: 30 },
  { label: "Chapa madera haya", value: 31 },
  { label: "Chapa madera nogal", value: 32 },
  { label: "Chapa madera wengué", value: 33 },
  { label: "Chapa madera teca", value: 34 },

  { label: "Hierro lacado alto brillo", value: 40 },
  { label: "Hierro lacado mate/satinado", value: 41 },
  { label: "Latón cepillado", value: 42 },
  { label: "Cobre natural con pátina", value: 43 },
  { label: "Aluminio anodizado", value: 44 },
  { label: "Acero inoxidable", value: 45 }
];

const estructuraPrincipalV2 = [
  { label: "Tablero DM / MDF", value: 100 },
  { label: "Tablero contrachapado marino", value: 101 },
  { label: "Tablero OSB", value: 102 },

  { label: "Madera maciza pino", value: 110 },
  { label: "Madera maciza haya", value: 111 },
  { label: "Madera maciza roble", value: 112 },
  { label: "Madera maciza nogal", value: 113 },
  { label: "Madera maciza teca", value: 114 },
  { label: "Madera maciza cerezo", value: 115 },

  { label: "Hierro lacado", value: 120 },
  { label: "Acero inoxidable", value: 121 },
  { label: "Aluminio", value: 122 },

  { label: "Policarbonato", value: 130 },
  { label: "Hormigón GRC", value: 131 }
];

const iluminacionV2 = [
  { label: "Sin iluminación", value: 0 },
  { label: "LED tira básica", value: 1 },
  { label: "LED tira regulable", value: 2 },
  { label: "LED tira regulable + mando", value: 3 },
  { label: "Retroiluminación pantalla/panel", value: 4 },
  { label: "Lightbox", value: 5 }
];


const handleCalcularPrecio = async (esA = true) => {
  const estados = esA
    ? {
        selectedNivel1: selectedNivel1_A,
        selectedNivel2: selectedNivel2_A,
        selectedNivel3: selectedNivel3_A,
        selectedAncho:
          selectedAncho_A.value != undefined
            ? selectedAncho_A.value
            : selectedAncho_A.target.value,
        selectedLargo:
          selectedLargo_A.value != undefined
            ? selectedLargo_A.value
            : selectedLargo_A.target.value,
        selectedAlto:
          selectedAlto_A.value != undefined
            ? selectedAlto_A.value
            : selectedAlto_A.target.value,
        selectedDiametro:
          selectedDiametro_A.value != undefined
            ? selectedDiametro_A.value
            : selectedDiametro_A.target.value,
        selectedCategoria: selectedCategoria_A,
        selectedAcabado1: selectedAcabado1_A,
        selectedEstructura1: selectedEstructura1_A,
        selectedLocalizacion: selectedLocalizacion_A,
        selectedAcabado2: selectedAcabado2_A,
        selectedAcabado3: selectedAcabado3_A,
        selectedEstructura2: selectedEstructura2_A,
        selectedEstructura3: selectedEstructura3_A,
        selectedIluminacion: selectedIluminacion_A,
        setCalculando: setCalculando_A,
        setPrecioCalculado: setPrecioCalculado_A,
      }
    : {
        selectedNivel1: selectedNivel1_B,
        selectedNivel2: selectedNivel2_B,
        selectedNivel3: selectedNivel3_B,
        selectedAncho:
          selectedAncho_B.value != undefined
            ? selectedAncho_B.value
            : selectedAncho_B.target.value,
        selectedLargo:
          selectedLargo_B.value != undefined
            ? selectedLargo_B.value
            : selectedLargo_B.target.value,
        selectedAlto:
          selectedAlto_B.value != undefined
            ? selectedAlto_B.value
            : selectedAlto_B.target.value,
        selectedDiametro:
          selectedDiametro_B.value != undefined
            ? selectedDiametro_B.value
            : selectedDiametro_B.target.value,
        selectedCategoria: selectedCategoria_B,
        selectedAcabado1: selectedAcabado1_B,
        selectedEstructura1: selectedEstructura1_B,
        selectedLocalizacion: selectedLocalizacion_B,
        selectedAcabado2: selectedAcabado2_B,
        selectedAcabado3: selectedAcabado3_B,
        selectedEstructura2: selectedEstructura2_B,
        selectedEstructura3: selectedEstructura3_B,
        selectedIluminacion: selectedIluminacion_B,
        setCalculando: setCalculando_B,
        setPrecioCalculado: setPrecioCalculado_B,
      };

  const camposRequeridos = [];

  if (!estados.selectedCategoria) camposRequeridos.push("Categoría");
  if (!estados.selectedAcabado1) camposRequeridos.push("Acabado Principal");
  if (!estados.selectedEstructura1) camposRequeridos.push("Estructura Principal");

  const camposOpcionales = [
    estados.selectedLocalizacion,
    estados.selectedAcabado2,
    estados.selectedAcabado3,
    estados.selectedEstructura2,
    estados.selectedEstructura3,
    estados.selectedIluminacion,
  ].filter(Boolean);

  if (camposRequeridos.length > 0 && !isV2) {
    notificationRef.current.addNotification(
      `${
        modoComparativa ? (esA ? "Configuración A: " : "Configuración B: ") : ""
      }Los siguientes campos son obligatorios: ${camposRequeridos.join(", ")}`,
      "warning"
    );
    return;
  }

  if (camposOpcionales.length === 0 && !isV2) {
    notificationRef.current.addNotification(
      `${
        modoComparativa ? (esA ? "Configuración A: " : "Configuración B: ") : ""
      }Selecciona al menos un campo adicional para calcular el precio.`,
      "warning"
    );
    return;
  }

  estados.setCalculando(true);
  if (esA) {
    setMostrarValoracion_A(false);
    setPrecioReal_A("");
    setPuntuacion_A(0);
    setComparacion_A("");
    setComentarios_A("");
    setValoracionGuardada_A(false);
  } else {
    setMostrarValoracion_B(false);
    setPrecioReal_B("");
    setPuntuacion_B(0);
    setComparacion_B("");
    setComentarios_B("");
    setValoracionGuardada_B(false);
  }

  const toMeters = (valor) => {
    if (typeof valor === "number") return valor / 100;
    if (typeof valor === "string" && valor !== "") return parseFloat(valor) / 100;
    return 0;
  };

  // ---------------------------------------------------------
  // Si isV2 -> mapeo y llamada a la nueva API (/price/average en 5002)
  // Si !isV2 -> comportamiento ORIGINAL: envío completo a /api/precios/predict (5001)
  // ---------------------------------------------------------

  if (isV2) {
    // Obtener códigos a partir de la selección única (soporta distintos formatos)
    let codNivel1 = Number(estados.selectedNivel1 ?? 0) || 0;
    let codNivel2 = Number(estados.selectedNivel2 ?? 0) || 0;
    let codNivel3 = Number(estados.selectedNivel3 ?? 0) || 0;

    // Intentamos mapear con nivelesMapping si la selección viene como label u objeto
    try {
      const sel = estados.selectedNivel1;
      if (sel) {
        const selValue = sel.value ?? sel;
        if (selValue && typeof selValue === "object" && ("nivel1" in selValue || "nivel2" in selValue || "nivel3" in selValue)) {
          codNivel1 = Number(selValue.nivel1 || codNivel1);
          codNivel2 = Number(selValue.nivel2 || codNivel2);
          codNivel3 = Number(selValue.nivel3 || codNivel3);
        } else {
          // buscar por label
          const label =
            typeof selValue === "string"
              ? selValue
              : sel.label && typeof sel.label === "string"
              ? sel.label
              : null;
          if (label) {
            const found = nivelesMapping.find((n) => n.label === label);
            if (found) {
              codNivel1 = Number(found.nivel1 || codNivel1);
              codNivel2 = Number(found.nivel2 || codNivel2);
              codNivel3 = Number(found.nivel3 || codNivel3);
            }
          }
        }
      }
    } catch (err) {
      // si algo falla, seguimos con los valores por defecto (no romper)
      console.warn("Error mapeando niveles V2:", err);
    }

    const predictionDataObj = {
      CodNivel1: codNivel1,
      CodNivel2: codNivel2,
      CodNivel3: codNivel3,
      Ancho: toMeters(estados.selectedAncho) || 0,
      Alto: toMeters(estados.selectedAlto) || 0,
      Largo: toMeters(estados.selectedLargo) || 0,
      Diametro: toMeters(estados.selectedDiametro) || 0,
      Estructura1: estados.selectedEstructura1?.value || 0,
      Acabado1: estados.selectedAcabado1?.value || 0,
      Acabado2: estados.selectedAcabado2?.value || 0,
      Iluminacion: estados.selectedIluminacion?.value || 0,
    };

    setPredictionData(predictionDataObj);

    const apiUrlV2 = window.config?.REACT_APP_API_URL || "http://localhost:5001";

    try {
      const response = await fetch(`${apiUrlV2}/api/precios/calculateV2`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(predictionDataObj),
      });

      const data = await response.json();

      setResponseAverage(data);

      console.log("Respuesta API V2:", data);

      // leer precio medio con fallbacks
      const precio =
        (data && data.precio_final) ?? 0;

      if (response.ok && precio !== 0) {
        estados.setPrecioCalculado(precio);
        notificationRef.current.addNotification(
          `${
            modoComparativa ? (esA ? "Configuración A: " : "Configuración B: ") : ""
          }Cálculo V2 obtenido correctamente: ${precio}`,
          "success"
        );
      } else {
        estados.setPrecioCalculado(0);
        notificationRef.current.addNotification(
          `${
            modoComparativa ? (esA ? "Configuración A: " : "Configuración B: ") : ""
          }No se encontró cálculo V2 para esta configuración.`,
          "warning"
        );
      }

      if (esA) setCalculoGuardado_A(false);
      else setCalculoGuardado_B(false);
    } catch (err) {
      estados.setPrecioCalculado(0);
      notificationRef.current.addNotification(
        `${
          modoComparativa ? (esA ? "Configuración A: " : "Configuración B: ") : ""
        }Error al obtener el cálculo V2.`,
        "error"
      );
    } finally {
      estados.setCalculando(false);
    }

    return;
  }

  // -----------------------
  // Modo clásico (no V2) — comportamiento original
  // -----------------------

  const predictionDataObj = {
    CodNivel1: estados.selectedNivel1?.value || 0,
    CodNivel2: estados.selectedNivel2?.value || 0,
    CodNivel3: estados.selectedNivel3?.value || 0,
    Ancho: toMeters(estados.selectedAncho) || 0,
    Largo: toMeters(estados.selectedLargo) || 0,
    Alto: toMeters(estados.selectedAlto) || 0,
    Diametro: toMeters(estados.selectedDiametro) || 0,
    CategoriaRevit: estados.selectedCategoria?.value || 0,
    Localizacion: estados.selectedLocalizacion?.value || 0,
    Acabado1: estados.selectedAcabado1?.value || 0,
    Acabado2: estados.selectedAcabado2?.value || 0,
    Acabado3: estados.selectedAcabado3?.value || 0,
    Estructura1: estados.selectedEstructura1?.value || 0,
    Estructura2: estados.selectedEstructura2?.value || 0,
    Estructura3: estados.selectedEstructura3?.value || 0,
    Iluminacion: estados.selectedIluminacion?.value || 0,
  };

  setPredictionData(predictionDataObj);

  const apiUrl = window.config?.REACT_APP_API_URL || "http://localhost:5001";

  try {
    const response = await fetch(`${apiUrl}/api/precios/predict`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(predictionDataObj),
    });

    const data = await response.json();

    console.log("Respuesta API:", data);

    // respuesta original usa data.prediction
    const prediction = data?.prediction ?? 0;

    estados.setPrecioCalculado(prediction);
    estados.setCalculando(false);

    if (esA) {
      setCalculoGuardado_A(false);
    } else {
      setCalculoGuardado_B(false);
    }

    notificationRef.current.addNotification(
      `${
        modoComparativa ? (esA ? "Configuración A: " : "Configuración B: ") : ""
      }Precio calculado correctamente: ${prediction}`,
      "success"
    );
  } catch (err) {
    estados.setCalculando(false);
    notificationRef.current.addNotification(
      `${
        modoComparativa ? (esA ? "Configuración A: " : "Configuración B: ") : ""
      }Error al calcular el precio.`,
      "error"
    );
  }
};

  const guardarValoracion = (esA) => {
    const precioReal = esA ? precioReal_A : precioReal_B;
    const puntuacion = esA ? puntuacion_A : puntuacion_B;
    const comparacion = esA ? comparacion_A : comparacion_B;
    const precioCalculado = esA ? precioCalculado_A : precioCalculado_B;

    if (activeTabFeedback == "precioReal" && (!precioReal || precioReal <= 0)) {
      notificationRef.current.addNotification(
        "Introduce un precio real válido",
        "warning"
      );
      return;
    }
    if (
      activeTabFeedback == "precision" &&
      (puntuacion < 1 || puntuacion > 5)
    ) {
      notificationRef.current.addNotification(
        "Selecciona una puntuación",
        "warning"
      );
      return;
    }

    if (
      activeTabFeedback == "precision" &&
      (!comparacion || comparacion.trim() === "")
    ) {
      notificationRef.current.addNotification(
        "Introduce una comparación",
        "warning"
      );
      return;
    }

    var feedbackData = null;
    const feedbackApiUrl =
      activeTabFeedback == "precision"
        ? "/api/precios/feedbackAdjustment"
        : "/api/precios/feedbackPrice";

    if (activeTabFeedback == "precision") {
      feedbackData = {
        features: predictionData,
        prediction: precioCalculado,
        confidence: puntuacion,
        direction: comparacion,
        isV2: isV2,
      };
    } else {
      feedbackData = {
        features: predictionData,
        actual_price: parseFloat(precioReal),
        prediction: precioCalculado,
        isV2: isV2,
      };
    }

    const apiUrl = window.config?.REACT_APP_API_URL || "http://localhost:5001";
    fetch(`${apiUrl}${feedbackApiUrl}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(feedbackData),
    })
      .then((data) => {
        notificationRef.current.addNotification(
          `${
            modoComparativa
              ? esA
                ? "Configuración A: "
                : "Configuración B: "
              : ""
          } Valoración enviada correctamente`,
          "success"
        );
        esA ? setMostrarValoracion_A(false) : setMostrarValoracion_B(false);
      })
      .catch((error) => {
        console.error("Error al enviar la valoración:", error);
        notificationRef.current.addNotification(
          `${
            modoComparativa
              ? esA
                ? "Configuración A: "
                : "Configuración B: "
              : ""
          } Error al enviar la valoración`,
          "error"
        );
      });
  };

  const renderValoracionPopup = (esA) => {
    const precioReal = esA ? precioReal_A : precioReal_B;
    const setPrecioReal = esA ? setPrecioReal_A : setPrecioReal_B;
    const puntuacion = esA ? puntuacion_A : puntuacion_B;
    const setPuntuacion = esA ? setPuntuacion_A : setPuntuacion_B;
    const comparacion = esA ? comparacion_A : comparacion_B;
    const setComparacion = esA ? setComparacion_A : setComparacion_B;
    const mostrarValoracion = esA ? mostrarValoracion_A : mostrarValoracion_B;
    const setMostrarValoracion = esA
      ? setMostrarValoracion_A
      : setMostrarValoracion_B;
    const precioCalculado = esA ? precioCalculado_A : precioCalculado_B;

    if (!mostrarValoracion) return null;

    const diferencia = precioReal
      ? ((parseFloat(precioReal) - precioCalculado) / precioCalculado) * 100
      : 0;

    return (
      <Popup
        type="info"
        titleMessage="Valorar Resultado de la IA"
        size="XL"
        onConfirm={() => guardarValoracion(esA)}
        onClose={() => setMostrarValoracion(false)}
        confirmLabel="Guardar Valoración"
        closeLabel="Cancelar"
      >
        <div className="valoracion-popup-content">
          <Tabs
            tabs={[
              { id: "precioReal", label: "Precio real" },
              { id: "precision", label: "Precisión" },
            ]}
            activeTab={activeTabFeedback}
            onTabChange={setActiveTabFeedback}
          />
          <div className="precio-ia-estimado">
            <div className="precio-ia-valor">
              {precioCalculado.toLocaleString("es-ES")} €
            </div>
          </div>

          {user !== null &&
            (user.codTipoEmpresa == 1 ||
            user.codTipoEmpresa == 2) && (
              <div className="valoracion-popup-fields">
                {activeTabFeedback === "precioReal" && (
                  <div className="valoracion-field">
                    <Input
                      label="Precio Real (€) *"
                      type="number"
                      value={precioReal}
                      onChange={(e) =>
                        setPrecioReal(e.target ? e.target.value : e)
                      }
                      placeholder="Introduce el precio real"
                      step="0.01"
                    />
                    {precioReal && (
                      <div
                        className={`diferencia-precio ${
                          diferencia > 0
                            ? "higher"
                            : diferencia < 0
                            ? "lower"
                            : "same"
                        }`}
                      >
                        <div className="diferencia-principal">
                          {diferencia > 0
                            ? `+${diferencia.toFixed(1)}% más caro`
                            : diferencia < 0
                            ? `${diferencia.toFixed(1)}% más barato`
                            : "Precio igual"}
                        </div>
                        <div className="diferencia-secundaria">
                          ({diferencia > 0 ? "+" : ""}
                          {(parseFloat(precioReal) - precioCalculado).toFixed(
                            2
                          )}
                          €)
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {activeTabFeedback === "precision" && (
                  <>
                    <div className="valoracion-field">
                      <label>Precisión del Resultado *</label>
                      <div className="estrellas-container">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <button
                            key={star}
                            className={`estrella ${
                              star <= puntuacion ? "activa" : "inactiva"
                            }`}
                            onClick={() => setPuntuacion(star)}
                            type="button"
                          >
                            {star <= puntuacion ? (
                              <HiStar />
                            ) : (
                              <HiOutlineStar />
                            )}
                          </button>
                        ))}
                      </div>
                      <div className="puntuacion-texto">
                        {puntuacion === 0 && "Selecciona una puntuación"}
                        {puntuacion === 1 && "Muy impreciso"}
                        {puntuacion === 2 && "Poco preciso"}
                        {puntuacion === 3 && "Aceptable"}
                        {puntuacion === 4 && "Bastante preciso"}
                        {puntuacion === 5 && "Muy preciso"}
                      </div>
                    </div>

                    <div className="valoracion-field">
                      <label>Comparación Rápida</label>
                      <div className="comparacion-botones">
                        <button
                          type="button"
                          className={`comparacion-btn ${
                            comparacion === "lower" ? "activo" : ""
                          }`}
                          onClick={() => setComparacion("lower")}
                        >
                          <HiOutlineTrendingDown className="comparacion-icon" />
                          <span>Más bajo</span>
                        </button>
                        <button
                          type="button"
                          className={`comparacion-btn ${
                            comparacion === "same" ? "activo" : ""
                          }`}
                          onClick={() => setComparacion("same")}
                        >
                          <HiOutlineDotsHorizontal className="comparacion-icon" />
                          <span>Similar</span>
                        </button>
                        <button
                          type="button"
                          className={`comparacion-btn ${
                            comparacion === "higher" ? "activo" : ""
                          }`}
                          onClick={() => setComparacion("higher")}
                        >
                          <HiOutlineTrendingUp className="comparacion-icon" />
                          <span>Más alto</span>
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
        </div>
      </Popup>
    );
  };

  const ValoracionPrecio = ({ esA, precioCalculado }) => {
    const precioReal = esA ? precioReal_A : precioReal_B;
    const setPrecioReal = esA ? setPrecioReal_A : setPrecioReal_B;
    const puntuacion = esA ? puntuacion_A : puntuacion_B;
    const setPuntuacion = esA ? setPuntuacion_A : setPuntuacion_B;
    const comparacion = esA ? comparacion_A : comparacion_B;
    const setComparacion = esA ? setComparacion_A : setComparacion_B;
    const mostrarValoracion = esA ? mostrarValoracion_A : mostrarValoracion_B;
    const setMostrarValoracion = esA
      ? setMostrarValoracion_A
      : setMostrarValoracion_B;

    if (!mostrarValoracion) return null;

    const diferencia = precioReal.value
      ? ((parseFloat(precioReal.value) - precioCalculado) / precioCalculado) *
        100
      : 0;

    const guardarValoracion = (esA) => {
      const precioReal = esA ? precioReal_A : precioReal_B;
      const puntuacion = esA ? puntuacion_A : puntuacion_B;
      const comparacion = esA ? comparacion_A : comparacion_B;
      const precioCalculado = esA ? precioCalculado_A : precioCalculado_B;

      if (!precioReal || puntuacion === 0) {
        notificationRef.current.addNotification(
          "Completa al menos el precio real y la puntuación",
          "warning"
        );
        return;
      }

      const diferencia = precioReal
        ? ((parseFloat(precioReal) - precioCalculado) / precioCalculado) * 100
        : 0;

      const valoracion = {
        id: Date.now(),
        fecha: new Date().toISOString(),
        precioIA: precioCalculado,
        precioReal: parseFloat(precioReal),
        puntuacion: puntuacion,
        comparacion: comparacion,
        diferenciaPorcentual: diferencia.toFixed(2),
      };

      const valoraciones = JSON.parse(
        localStorage.getItem("valoracionesPrecios") || "[]"
      );
      valoraciones.push(valoracion);
      localStorage.setItem("valoracionesPrecios", JSON.stringify(valoraciones));

      if (esA) {
        setValoracionGuardada_A(true);
        setMostrarValoracion_A(false);
      } else {
        setValoracionGuardada_B(true);
        setMostrarValoracion_B(false);
      }

      notificationRef.current.addNotification(
        "¡Valoración guardada correctamente!",
        "success"
      );
    };
    const renderValoracionPopup = (esA) => {
      const precioReal = esA ? precioReal_A : precioReal_B;
      const setPrecioReal = esA ? setPrecioReal_A : setPrecioReal_B;
      const puntuacion = esA ? puntuacion_A : puntuacion_B;
      const setPuntuacion = esA ? setPuntuacion_A : setPuntuacion_B;
      const comparacion = esA ? comparacion_A : comparacion_B;
      const setComparacion = esA ? setComparacion_A : setComparacion_B;
      const mostrarValoracion = esA ? mostrarValoracion_A : mostrarValoracion_B;
      const setMostrarValoracion = esA
        ? setMostrarValoracion_A
        : setMostrarValoracion_B;
      const precioCalculado = esA ? precioCalculado_A : precioCalculado_B;

      if (!mostrarValoracion) return null;

      const diferencia = precioReal
        ? ((parseFloat(precioReal) - precioCalculado) / precioCalculado) * 100
        : 0;

      return (
        <Popup
          type="info"
          titleMessage="Valorar Resultado de la IA"
          size="XL"
          onConfirm={() => guardarValoracion(esA)}
          onClose={() => setMostrarValoracion(false)}
          confirmLabel="Guardar Valoración"
          closeLabel="Cancelar"
        >
          <div className="valoracion-popup-content">
            <div className="valoracion-popup-header">
              <HiOutlineCog className="valoracion-popup-icon" />
              <p>
                Ayúdanos a mejorar la precisión del modelo de IA proporcionando
                feedback sobre el resultado.
              </p>
            </div>

            <div className="valoracion-popup-fields">
              <div className="valoracion-field">
                <Input
                  label="Precio Real (€) *"
                  type="number"
                  value={precioReal}
                  onChange={(e) => setPrecioReal(e.target ? e.target.value : e)}
                  placeholder="Introduce el precio real"
                  step="0.01"
                />
                {precioReal && (
                  <div
                    className={`diferencia-precio ${
                      diferencia > 0
                        ? "higher"
                        : diferencia < 0
                        ? "lower"
                        : "same"
                    }`}
                  >
                    <div className="diferencia-principal">
                      {diferencia > 0
                        ? `+${diferencia.toFixed(1)}% más caro`
                        : diferencia < 0
                        ? `${diferencia.toFixed(1)}% más barato`
                        : "Precio igual"}
                    </div>
                    <div className="diferencia-secundaria">
                      ({diferencia > 0 ? "+" : ""}
                      {(parseFloat(precioReal) - precioCalculado).toFixed(2)}
                      €)
                    </div>
                  </div>
                )}
              </div>

              <div className="valoracion-field">
                <label>Precisión del Resultado *</label>
                <div className="estrellas-container">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      className={`estrella ${
                        star <= puntuacion ? "activa" : "inactiva"
                      }`}
                      onClick={() => setPuntuacion(star)}
                      type="button"
                    >
                      {star <= puntuacion ? <HiStar /> : <HiOutlineStar />}
                    </button>
                  ))}
                </div>
                <div className="puntuacion-texto">
                  {puntuacion === 0 && "Selecciona una puntuación"}
                  {puntuacion === 1 && "Muy impreciso"}
                  {puntuacion === 2 && "Poco preciso"}
                  {puntuacion === 3 && "Aceptable"}
                  {puntuacion === 4 && "Bastante preciso"}
                  {puntuacion === 5 && "Muy preciso"}
                </div>
              </div>

              <div className="valoracion-field">
                <label>Comparación Rápida</label>
                <div className="comparacion-botones">
                  <button
                    type="button"
                    className={`comparacion-btn ${
                      comparacion === "lower" ? "activo" : ""
                    }`}
                    onClick={() => setComparacion("lower")}
                  >
                    <HiOutlineTrendingDown className="comparacion-icon" />
                    <span>Más bajo</span>
                  </button>
                  <button
                    type="button"
                    className={`comparacion-btn ${
                      comparacion === "same" ? "activo" : ""
                    }`}
                    onClick={() => setComparacion("same")}
                  >
                    <HiOutlineDotsHorizontal className="comparacion-icon" />
                    <span>Similar</span>
                  </button>
                  <button
                    type="button"
                    className={`comparacion-btn ${
                      comparacion === "higher" ? "activo" : ""
                    }`}
                    onClick={() => setComparacion("higher")}
                  >
                    <HiOutlineTrendingUp className="comparacion-icon" />
                    <span>Más alto</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Popup>
      );
    };

    return (
      <div className="valoracion-precio">
        <div className="valoracion-precio__header">
          <HiOutlineCog className="valoracion-precio__icon" />
          <div>
            <h4>Valorar Resultado de la IA</h4>
            <p>Ayúdanos a mejorar la precisión del modelo</p>
          </div>
        </div>

        <div className="valoracion-precio__content">
          <div className="valoracion-field">
            <Input
              label="Precio Real (€) *"
              type="number"
              value={precioReal.value}
              onChange={setPrecioReal}
              placeholder="Introduce el precio real"
              step="0.01"
            />
            {precioReal && (
              <div
                className={`diferencia-precio ${
                  diferencia > 0 ? "higher" : diferencia < 0 ? "lower" : "same"
                }`}
              >
                <div className="diferencia-principal">
                  {diferencia > 0
                    ? `+${diferencia.toFixed(1)}% más caro`
                    : diferencia < 0
                    ? `${diferencia.toFixed(1)}% más barato`
                    : "Precio igual"}
                </div>
                <div className="diferencia-secundaria">
                  ({diferencia > 0 ? "+" : ""}
                  {(parseFloat(precioReal) - precioCalculado).toFixed(2)}
                  €)
                </div>
              </div>
            )}
          </div>

          <div className="valoracion-field">
            <label>Precisión del Resultado *</label>
            <div className="estrellas-container">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  className={`estrella ${
                    star <= puntuacion ? "activa" : "inactiva"
                  }`}
                  onClick={() => setPuntuacion(star)}
                >
                  {star <= puntuacion ? <HiStar /> : <HiOutlineStar />}
                </button>
              ))}
            </div>
            <div className="puntuacion-texto">
              {puntuacion === 0 && "Selecciona una puntuación"}
              {puntuacion === 1 && "Muy impreciso"}
              {puntuacion === 2 && "Poco preciso"}
              {puntuacion === 3 && "Aceptable"}
              {puntuacion === 4 && "Bastante preciso"}
              {puntuacion === 5 && "Muy preciso"}
            </div>
          </div>

          <div className="valoracion-field">
            <label>Comparación Rápida</label>
            <div className="comparacion-botones">
              <button
                className={`comparacion-btn ${
                  comparacion === "lower" ? "activo" : ""
                }`}
                onClick={() => setComparacion("lower")}
              >
                <HiOutlineTrendingDown className="comparacion-icon" />
                <span>Más bajo</span>
              </button>
              <button
                className={`comparacion-btn ${
                  comparacion === "same" ? "activo" : ""
                }`}
                onClick={() => setComparacion("same")}
              >
                <HiOutlineDotsHorizontal className="comparacion-icon" />
                <span>Similar</span>
              </button>
              <button
                className={`comparacion-btn ${
                  comparacion === "higher" ? "activo" : ""
                }`}
                onClick={() => setComparacion("higher")}
              >
                <HiOutlineTrendingUp className="comparacion-icon" />
                <span>Más alto</span>
              </button>
            </div>
          </div>
        </div>

        <div className="valoracion-actions">
          <Button
            variant="outlined"
            label="Cancelar"
            onClick={() => setMostrarValoracion(false)}
          />
          <Button
            variant="filled"
            label="Guardar Valoración"
            onClick={guardarValoracion}
            disabled={!precioReal || puntuacion === 0}
          />
        </div>
      </div>
    );
  };

  const handleLimpiarFormulario = (esA = true) => {
    if (esA) {
      setSelectedAcabado1_A(null);
      setSelectedAcabado2_A(null);
      setSelectedAcabado3_A(null);
      setSelectedCategoria_A(null);
      setSelectedEstructura1_A(null);
      setSelectedEstructura2_A(null);
      setSelectedEstructura3_A(null);
      setSelectedIluminacion_A(null);
      setSelectedLocalizacion_A(null);
      setSelectedAncho_A({ value: 0 });
      setSelectedLargo_A({ value: 0 });
      setSelectedAlto_A({ value: 0 });
      setSelectedDiametro_A({ value: 0 });
      setSelectedNivel1_A(null);
      setSelectedNivel2_A(null);
      setSelectedNivel3_A(null);
      setPrecioCalculado_A(null);
      setFormKey_A((prev) => prev + 1);
      setCalculoGuardado_A(false);
      setHashCalculoActual_A(null);
      setPuntuacion_A(0);
      setComparacion_A("");
      setPrecioReal_A(0);
    } else {
      setSelectedAcabado1_B(null);
      setSelectedAcabado2_B(null);
      setSelectedAcabado3_B(null);
      setSelectedCategoria_B(null);
      setSelectedEstructura1_B(null);
      setSelectedEstructura2_B(null);
      setSelectedEstructura3_B(null);
      setSelectedIluminacion_B(null);
      setSelectedLocalizacion_B(null);
      setSelectedAncho_B({ value: 0 });
      setSelectedLargo_B({ value: 0 });
      setSelectedAlto_B({ value: 0 });
      setSelectedDiametro_B({ value: 0 });
      setSelectedNivel1_B(null);
      setSelectedNivel2_B(null);
      setSelectedNivel3_B(null);
      setPrecioCalculado_B(null);
      setFormKey_B((prev) => prev + 1);
      setCalculoGuardado_B(false);
      setHashCalculoActual_B(null);
      setPuntuacion_B(0);
      setComparacion_B("");
      setPrecioReal_B(0);
    }

    notificationRef.current.addNotification(
      `${
        modoComparativa ? (esA ? "Configuración A: " : "Configuración B: ") : ""
      }Formulario limpiado correctamente.`,
      "info"
    );

    if (esA) {
      setMostrarValoracion_A(false);
      setPrecioReal_A({ value: "" });
      setPuntuacion_A(0);
      setComparacion_A("");
      setComentarios_A("");
      setValoracionGuardada_A(false);
    } else {
      setMostrarValoracion_B(false);
      setPrecioReal_B({ value: "" });
      setPuntuacion_B(0);
      setComparacion_B("");
      setComentarios_B("");
      setValoracionGuardada_B(false);
    }
  };

  const guardarCalculo = (esA = true) => {
    const estados = esA
      ? {
          selectedCategoria: selectedCategoria_A,
          selectedLocalizacion: selectedLocalizacion_A,
          selectedNivel1: selectedNivel1_A,
          selectedNivel2: selectedNivel2_A,
          selectedNivel3: selectedNivel3_A,
          selectedAncho: selectedAncho_A,
          selectedLargo: selectedLargo_A,
          selectedAlto: selectedAlto_A,
          selectedDiametro: selectedDiametro_A,
          selectedAcabado1: selectedAcabado1_A,
          selectedAcabado2: selectedAcabado2_A,
          selectedAcabado3: selectedAcabado3_A,
          selectedEstructura1: selectedEstructura1_A,
          selectedEstructura2: selectedEstructura2_A,
          selectedEstructura3: selectedEstructura3_A,
          selectedIluminacion: selectedIluminacion_A,
          precioCalculado: precioCalculado_A,
          tipo: "simple",
        }
      : {
          selectedCategoria: selectedCategoria_B,
          selectedLocalizacion: selectedLocalizacion_B,
          selectedNivel1: selectedNivel1_B,
          selectedNivel2: selectedNivel2_B,
          selectedNivel3: selectedNivel3_B,
          selectedAncho: selectedAncho_B,
          selectedLargo: selectedLargo_B,
          selectedAlto: selectedAlto_B,
          selectedDiametro: selectedDiametro_B,
          selectedAcabado1: selectedAcabado1_B,
          selectedAcabado2: selectedAcabado2_B,
          selectedAcabado3: selectedAcabado3_B,
          selectedEstructura1: selectedEstructura1_B,
          selectedEstructura2: selectedEstructura2_B,
          selectedEstructura3: selectedEstructura3_B,
          selectedIluminacion: selectedIluminacion_B,
          precioCalculado: precioCalculado_B,
          tipo: "comparativa",
        };

    if (!estados.precioCalculado) {
      notificationRef.current.addNotification(
        "Primero debes calcular un precio para poder guardarlo",
        "warning"
      );
      return;
    }

    const nuevoCalculo = {
      ...estados,
      id: Date.now(),
      fecha: new Date().toLocaleString(),
      nombre: `Cálculo ${
        modoComparativa ? (esA ? "A" : "B") : ""
      } - ${new Date().toLocaleString()}`,
    };

    const nuevosCalculos = [...calculosGuardados, nuevoCalculo];
    setCalculosGuardados(nuevosCalculos);
    localStorage.setItem("calculosGuardados", JSON.stringify(nuevosCalculos));

    if (esA) {
      setCalculoGuardado_A(true);
      setHashCalculoActual_A(generarHashCalculo(estados));
    } else {
      setCalculoGuardado_B(true);
      setHashCalculoActual_B(generarHashCalculo(estados));
    }

    notificationRef.current.addNotification(
      "Cálculo guardado correctamente",
      "success"
    );
  };

  const eliminarCalculoGuardado = (id) => {
    const nuevosCalculos = calculosGuardados.filter((calc) => calc.id !== id);
    setCalculosGuardados(nuevosCalculos);
    localStorage.setItem("calculosGuardados", JSON.stringify(nuevosCalculos));
  };

  const renderMedidas = (estados) => {
    const medidas = [];

    if (estados.selectedAncho?.value > 0) {
      medidas.push(`Ancho: ${estados.selectedAncho.value}m`);
    }
    if (estados.selectedLargo?.value > 0) {
      medidas.push(`Largo: ${estados.selectedLargo.value}m`);
    }
    if (estados.selectedAlto?.value > 0) {
      medidas.push(`Alto: ${estados.selectedAlto.value}m`);
    }
    if (estados.selectedDiametro?.value > 0) {
      medidas.push(`Diámetro: ${estados.selectedDiametro.value}m`);
    }

    return medidas.length > 0 ? medidas.join(" • ") : null;
  };

  const renderFormulario = (esA = true, titulo = "") => {
    const estados = esA
      ? {
          selectedCategoria: selectedCategoria_A,
          selectedLocalizacion: selectedLocalizacion_A,
          selectedNivel1: selectedNivel1_A,
          selectedNivel2: selectedNivel2_A,
          selectedNivel3: selectedNivel3_A,
          selectedAncho: selectedAncho_A,
          selectedLargo: selectedLargo_A,
          selectedAlto: selectedAlto_A,
          selectedDiametro: selectedDiametro_A,
          selectedAcabado1: selectedAcabado1_A,
          selectedAcabado2: selectedAcabado2_A,
          selectedAcabado3: selectedAcabado3_A,
          selectedEstructura1: selectedEstructura1_A,
          selectedEstructura2: selectedEstructura2_A,
          selectedEstructura3: selectedEstructura3_A,
          selectedIluminacion: selectedIluminacion_A,
          precioCalculado: precioCalculado_A,
          calculando: calculando_A,
          formKey: formKey_A,
          calculoGuardado: calculoGuardado_A,
          setters: {
            setSelectedCategoria: setSelectedCategoria_A,
            setSelectedLocalizacion: setSelectedLocalizacion_A,
            setSelectedNivel1: setSelectedNivel1_A,
            setSelectedNivel2: setSelectedNivel2_A,
            setSelectedNivel3: setSelectedNivel3_A,
            setSelectedAncho: setSelectedAncho_A,
            setSelectedLargo: setSelectedLargo_A,
            setSelectedAlto: setSelectedAlto_A,
            setSelectedDiametro: setSelectedDiametro_A,
            setSelectedAcabado1: setSelectedAcabado1_A,
            setSelectedAcabado2: setSelectedAcabado2_A,
            setSelectedAcabado3: setSelectedAcabado3_A,
            setSelectedEstructura1: setSelectedEstructura1_A,
            setSelectedEstructura2: setSelectedEstructura2_A,
            setSelectedEstructura3: setSelectedEstructura3_A,
            setSelectedIluminacion: setSelectedIluminacion_A,
          },
        }
      : {
          selectedCategoria: selectedCategoria_B,
          selectedLocalizacion: selectedLocalizacion_B,
          selectedNivel1: selectedNivel1_B,
          selectedNivel2: selectedNivel2_B,
          selectedNivel3: selectedNivel3_B,
          selectedAncho: selectedAncho_B,
          selectedLargo: selectedLargo_B,
          selectedAlto: selectedAlto_B,
          selectedDiametro: selectedDiametro_B,
          selectedAcabado1: selectedAcabado1_B,
          selectedAcabado2: selectedAcabado2_B,
          selectedAcabado3: selectedAcabado3_B,
          selectedEstructura1: selectedEstructura1_B,
          selectedEstructura2: selectedEstructura2_B,
          selectedEstructura3: selectedEstructura3_B,
          selectedIluminacion: selectedIluminacion_B,
          precioCalculado: precioCalculado_B,
          calculando: calculando_B,
          formKey: formKey_B,
          calculoGuardado: calculoGuardado_B,
          setters: {
            setSelectedCategoria: setSelectedCategoria_B,
            setSelectedLocalizacion: setSelectedLocalizacion_B,
            setSelectedNivel1: setSelectedNivel1_B,
            setSelectedNivel2: setSelectedNivel2_B,
            setSelectedNivel3: setSelectedNivel3_B,
            setSelectedAncho: setSelectedAncho_B,
            setSelectedLargo: setSelectedLargo_B,
            setSelectedAlto: setSelectedAlto_B,
            setSelectedDiametro: setSelectedDiametro_B,
            setSelectedAcabado1: setSelectedAcabado1_B,
            setSelectedAcabado2: setSelectedAcabado2_B,
            setSelectedAcabado3: setSelectedAcabado3_B,
            setSelectedEstructura1: setSelectedEstructura1_B,
            setSelectedEstructura2: setSelectedEstructura2_B,
            setSelectedEstructura3: setSelectedEstructura3_B,
            setSelectedIluminacion: setSelectedIluminacion_B,
          },
        };

    return (
      <div className="precio__form" key={estados.formKey}>
        {titulo && (
          <h3
            style={{
              textAlign: "center",
              marginBottom: "40px",
              fontSize: "18px",
              color: "black",
            }}
          >
            {titulo}
          </h3>
        )}
{
     !isV2 && (   <div className="precio__form__row">
          <div className="precio__form__input">
            <InputDropdown
              label="Categoría *"
              options={categoriaOptions}
              onSelect={estados.setters.setSelectedCategoria}
              value={estados.selectedCategoria}
              placeholder="Selecciona una categoría"
              hasSearch={true}
            />
          </div>
          <div className="precio__form__input">
            <InputDropdown
              label="Localización"
              options={localizacionOptions}
              onSelect={estados.setters.setSelectedLocalizacion}
              value={estados.selectedLocalizacion}
              placeholder="Selecciona localización"
              hasSearch={true}
            />
          </div>
        </div>
     )
}

        <div className="precio__form__section">
  <h3>Niveles</h3>

  {isV2 ? (
    <div className="precio__form__row">
      <div className="precio__form__input">
        <InputDropdown
          label="Nivel"
          options={nivelesMapping.map(n => ({
            label: n.label,
            value: {
              nivel1: n.nivel1,
              nivel2: n.nivel2,
              nivel3: n.nivel3,
            },
          }))}
          onSelect={(selected) => {
            estados.setters.setSelectedNivel1(selected.value.nivel1);
            estados.setters.setSelectedNivel2(selected.value.nivel2);
            estados.setters.setSelectedNivel3(selected.value.nivel3);
          }}
          value={
            estados.selectedNivel1 &&
            estados.selectedNivel2 &&
            estados.selectedNivel3
              ? nivelesMapping.find(
                  n =>
                    n.nivel1 === estados.selectedNivel1 &&
                    n.nivel2 === estados.selectedNivel2 &&
                    n.nivel3 === estados.selectedNivel3
                )?.label
              : null
          }
          placeholder="Selecciona nivel"
          hasSearch={true}
        />
      </div>
    </div>
  ) : (
    <div className="precio__form__row three-columns">
      <div className="precio__form__input">
        <InputDropdown
          label="Nivel 1"
          options={nivel1Options}
          onSelect={estados.setters.setSelectedNivel1}
          value={estados.selectedNivel1}
          placeholder="Selecciona nivel 1"
          hasSearch={true}
        />
      </div>
      <div className="precio__form__input">
        <InputDropdown
          label="Nivel 2"
          options={nivel2Options}
          onSelect={estados.setters.setSelectedNivel2}
          value={estados.selectedNivel2}
          placeholder="Selecciona nivel 2"
          hasSearch={true}
        />
      </div>
      <div className="precio__form__input">
        <InputDropdown
          label="Nivel 3"
          options={nivel3Options}
          onSelect={estados.setters.setSelectedNivel3}
          value={estados.selectedNivel3}
          placeholder="Selecciona nivel 3"
          hasSearch={true}
        />
      </div>
    </div>
  )}
</div>

        <div className="precio__form__section">
          <h3>Medidas</h3>
          <div className="precio__form__row three-columns">
            <div className="precio__form__input">
              <Input
                label="Ancho (cm)"
                type="number"
                onChange={estados.setters.setSelectedAncho}
                value={estados.selectedAncho.value}
                placeholder="Introduce ancho"
              />
            </div>
            <div className="precio__form__input">
              <Input
                label="Largo (cm)"
                type="number"
                onChange={estados.setters.setSelectedLargo}
                value={estados.selectedLargo.value}
                placeholder="Introduce largo"
              />
            </div>
            <div className="precio__form__input">
              <Input
                label="Alto (cm)"
                type="number"
                onChange={estados.setters.setSelectedAlto}
                value={estados.selectedAlto.value}
                placeholder="Introduce altura"
              />
            </div>
            <div className="precio__form__input">
              <Input
                label="Diametro (cm)"
                type="number"
                onChange={estados.setters.setSelectedDiametro}
                value={estados.selectedDiametro.value}
                placeholder="Introduce diámetro"
              />
            </div>
          </div>
        </div>

        <div className="precio__form__section">
          <h3>Acabados</h3>
          <div className="precio__form__row three-columns">
            <div className="precio__form__input">
              <InputDropdown
                label="Acabado Principal"
                options={!isV2 ? acabado1Options : acabadoPrincipalV2}
                onSelect={estados.setters.setSelectedAcabado1}
                value={estados.selectedAcabado1}
                placeholder="Selecciona acabado principal"
                hasSearch={true}
              />
            </div>
            <div className="precio__form__input">
              <InputDropdown
                label="Acabado Secundario"
                options={!isV2 ? acabado2Options : acabadoSecundarioV2}
                onSelect={estados.setters.setSelectedAcabado2}
                value={estados.selectedAcabado2}
                placeholder="Selecciona acabado secundario"
                hasSearch={true}
              />
            </div>
            {
              !isV2 && (
                            <div className="precio__form__input">
              <InputDropdown
                label="Acabado Terciario"
                options={acabado3Options}
                onSelect={estados.setters.setSelectedAcabado3}
                value={estados.selectedAcabado3}
                placeholder="Selecciona acabado terciario"
                hasSearch={true}
              />
            </div>
              )
            }
          </div>
        </div>

        <div className="precio__form__section">
          <h3>Estructura</h3>
          <div className="precio__form__row three-columns">
            <div className="precio__form__input">
              <InputDropdown
                label="Estructura Principal"
                options={!isV2 ? estructura1Options : estructuraPrincipalV2}
                onSelect={estados.setters.setSelectedEstructura1}
                value={estados.selectedEstructura1}
                placeholder="Selecciona estructura principal"
                hasSearch={true}
              />
            </div>
            {
              !isV2 && (
                <>
                  <div className="precio__form__input">
                  <InputDropdown
                    label="Estructura Secundaria"
                    options={estructura2Options}
                    onSelect={estados.setters.setSelectedEstructura2}
                    value={estados.selectedEstructura2}
                    placeholder="Selecciona estructura secundaria"
                    hasSearch={true}
                  />
                </div>
                <div className="precio__form__input">
                  <InputDropdown
                    label="Estructura Terciaria"
                    options={estructura3Options}
                    onSelect={estados.setters.setSelectedEstructura3}
                    value={estados.selectedEstructura3}
                    placeholder="Selecciona estructura terciaria"
                    hasSearch={true}
                  />
                </div>
                </>
              )
            }
          </div>
        </div>

        <div className="precio__form__section">
          <h3>Características Adicionales</h3>
          <div className="precio__form__row single-column">
            <div className="precio__form__input">
              <InputDropdown
                label="Iluminación"
                options={isV2 ? iluminacionV2 : iluminacionOptions}
                onSelect={estados.setters.setSelectedIluminacion}
                value={estados.selectedIluminacion}
                placeholder="Selecciona tipo de iluminación"
                hasSearch={true}
              />
            </div>
          </div>
        </div>

        <div className="precio__form__actions">
          <Button
            variant="filled"
            label={estados.calculando ? "Calculando..." : "Calcular Precio"}
            icon={<HiOutlineCalculator />}
            onClick={() => handleCalcularPrecio(esA)}
            disabled={estados.calculando}
          />
          <Button
            variant="outlined"
            label="Limpiar Formulario"
            onClick={() => handleLimpiarFormulario(esA)}
            disabled={estados.calculando}
          />
          {estados.precioCalculado && (
            <Button
              variant={estados.calculoGuardado ? "filled" : "outlined"}
              label={estados.calculoGuardado ? "Guardado" : "Guardar Cálculo"}
              icon={estados.calculoGuardado ? <HiCheck /> : <HiOutlineSave />}
              onClick={() => guardarCalculo(esA)}
              disabled={estados.calculoGuardado}
              className={estados.calculoGuardado ? "button--saved" : ""}
            />
          )}
        </div>

        {estados.precioCalculado && (
          <div className="precio__result">
            <div className="precio__result__card">
              <h3>{isV2 ? "Precio medio" : "Precio estimado"}</h3>
              <div className="precio__result__price">
                {estados.precioCalculado.toLocaleString("es-ES")} €
              </div>
            </div>
          </div>
        )}

        {estados.precioCalculado && 
            user !== null &&
            (user.codTipoEmpresa == 1 ||
            user.codTipoEmpresa == 2) && (
          <div style={{ margin: "16px 0", textAlign: "center" }}>
            {!(esA ? valoracionGuardada_A : valoracionGuardada_B) ? (
              <Button
                variant="outlined"
                label="Valorar Resultado"
                icon={<HiStar />}
                onClick={() =>
                  esA
                    ? setMostrarValoracion_A(true)
                    : setMostrarValoracion_B(true)
                }
              />
            ) : (
              <div
                style={{
                  color: "green",
                  fontWeight: "600",
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <HiCheck /> Valoración completada - ¡Gracias!
              </div>
            )}
          </div>
        )}

        {estados.precioCalculado && (
          <div className="precio__summary">
            <h3>Resumen de Características Seleccionadas</h3>
            <div className="precio__summary__content">
              {estados.selectedCategoria && (
                <div className="precio__summary__item">
                  <strong>Categoría:</strong> {estados.selectedCategoria.label}
                </div>
              )}
              {estados.selectedLocalizacion && (
                <div className="precio__summary__item">
                  <strong>Localización:</strong>{" "}
                  {estados.selectedLocalizacion.label}
                </div>
              )}
              {estados.selectedNivel1 && (
                <div className="precio__summary__item">
                  <strong>Nivel 1:</strong> {isV2 ? nivelesMapping.find(x=>x.nivel1 == estados.selectedNivel1 && x.nivel2 == estados.selectedNivel2 && x.nivel3 == estados.selectedNivel3).label.split(" ")[0]
 : estados.selectedNivel1.label}
                </div>
              )}
              {estados.selectedNivel2 && (
                <div className="precio__summary__item">
                  <strong>Nivel 2:</strong> {isV2 ? nivelesMapping.find(x=>x.nivel1 == estados.selectedNivel1 && x.nivel2 == estados.selectedNivel2 && x.nivel3 == estados.selectedNivel3).label.split(" ")[1]
 : estados.selectedNivel2.label}
                </div>
              )}
              {estados.selectedNivel3 && (
                <div className="precio__summary__item">
                  <strong>Nivel 3:</strong> {isV2 ? nivelesMapping.find(x=>x.nivel1 == estados.selectedNivel1 && x.nivel2 == estados.selectedNivel2 && x.nivel3 == estados.selectedNivel3).label.split(" ")[2]
 : estados.selectedNivel3.label}
                </div>
              )}
              {(estados.selectedAncho?.value > 0 ||
                estados.selectedLargo?.value > 0 ||
                estados.selectedAlto?.value > 0 ||
                estados.selectedDiametro?.value > 0) && (
                <div className="precio__summary__item">
                  <strong>Medidas:</strong> {renderMedidas(estados)}
                </div>
              )}
              {estados.selectedAcabado1 && (
                <div className="precio__summary__item">
                  <strong>Acabado Principal:</strong>{" "}
                  {estados.selectedAcabado1.label}
                </div>
              )}
              {estados.selectedAcabado2 && (
                <div className="precio__summary__item">
                  <strong>Acabado Secundario:</strong>{" "}
                  {estados.selectedAcabado2.label}
                </div>
              )}
              {estados.selectedAcabado3 && (
                <div className="precio__summary__item">
                  <strong>Acabado Terciario:</strong>{" "}
                  {estados.selectedAcabado3.label}
                </div>
              )}
              {estados.selectedEstructura1 && (
                <div className="precio__summary__item">
                  <strong>Estructura Principal:</strong>{" "}
                  {estados.selectedEstructura1.label}
                </div>
              )}
              {estados.selectedEstructura2 && (
                <div className="precio__summary__item">
                  <strong>Estructura Secundaria:</strong>{" "}
                  {estados.selectedEstructura2.label}
                </div>
              )}
              {estados.selectedEstructura3 && (
                <div className="precio__summary__item">
                  <strong>Estructura Terciaria:</strong>{" "}
                  {estados.selectedEstructura3.label}
                </div>
              )}
              {estados.selectedIluminacion && (
                <div className="precio__summary__item">
                  <strong>Iluminación:</strong>{" "}
                  {estados.selectedIluminacion.label}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const CalculosGuardadosModal = () => (
    <Modal
      isOpen={mostrarCalculosGuardados}
      onClose={() => setMostrarCalculosGuardados(false)}
      title="Cálculos Guardados"
      size="lg"
    >
      <div className="calculos-guardados">
        {calculosGuardados.length === 0 ? (
          <div className="calculos-guardados__empty">
            <p>No hay cálculos guardados</p>
          </div>
        ) : (
          <div className="calculos-guardados__lista">
            {calculosGuardados.map((calculo) => (
              <div key={calculo.id} className="calculos-guardados__item">
                <div className="calculos-guardados__header">
                  <div className="calculos-guardados__title">
                    <h4>{calculo.nombre}</h4>
                    <span className="calculos-guardados__fecha">
                      {calculo.fecha}
                    </span>
                  </div>
                  <span className="calculos-guardados__precio">
                    {calculo.precioCalculado.toLocaleString("es-ES")} €
                  </span>
                </div>

                <div className="calculos-guardados__resumen">
                  {calculo.selectedCategoria && (
                    <div className="calculos-guardados__field">
                      <strong>Categoría:</strong>{" "}
                      {calculo.selectedCategoria.label}
                    </div>
                  )}
                  {calculo.selectedLocalizacion && (
                    <div className="calculos-guardados__field">
                      <strong>Localización:</strong>{" "}
                      {calculo.selectedLocalizacion.label}
                    </div>
                  )}
                  {calculo.selectedNivel1 && (
                    <div className="calculos-guardados__field">
                      <strong>Nivel 1:</strong> {calculo.selectedNivel1.label}
                    </div>
                  )}
                  {calculo.selectedNivel2 && (
                    <div className="calculos-guardados__field">
                      <strong>Nivel 2:</strong> {calculo.selectedNivel2.label}
                    </div>
                  )}
                  {calculo.selectedNivel3 && (
                    <div className="calculos-guardados__field">
                      <strong>Nivel 3:</strong> {calculo.selectedNivel3.label}
                    </div>
                  )}
                  {renderMedidas(calculo) && (
                    <div className="calculos-guardados__field">
                      <strong>Medidas:</strong> {renderMedidas(calculo)}
                    </div>
                  )}
                  {calculo.selectedAcabado1 && (
                    <div className="calculos-guardados__field">
                      <strong>Acabado Principal:</strong>{" "}
                      {calculo.selectedAcabado1.label}
                    </div>
                  )}
                  {calculo.selectedAcabado2 && (
                    <div className="calculos-guardados__field">
                      <strong>Acabado Secundario:</strong>{" "}
                      {calculo.selectedAcabado2.label}
                    </div>
                  )}
                  {calculo.selectedAcabado3 && (
                    <div className="calculos-guardados__field">
                      <strong>Acabado Terciario:</strong>{" "}
                      {calculo.selectedAcabado3.label}
                    </div>
                  )}
                  {calculo.selectedEstructura1 && (
                    <div className="calculos-guardados__field">
                      <strong>Estructura Principal:</strong>{" "}
                      {calculo.selectedEstructura1.label}
                    </div>
                  )}
                  {calculo.selectedEstructura2 && (
                    <div className="calculos-guardados__field">
                      <strong>Estructura Secundaria:</strong>{" "}
                      {calculo.selectedEstructura2.label}
                    </div>
                  )}
                  {calculo.selectedEstructura3 && (
                    <div className="calculos-guardados__field">
                      <strong>Estructura Terciaria:</strong>{" "}
                      {calculo.selectedEstructura3.label}
                    </div>
                  )}
                  {calculo.selectedIluminacion && (
                    <div className="calculos-guardados__field">
                      <strong>Iluminación:</strong>{" "}
                      {calculo.selectedIluminacion.label}
                    </div>
                  )}
                </div>

                <div className="calculos-guardados__actions">
                  <Button
                    variant="text"
                    label="Eliminar"
                    onClick={() => eliminarCalculoGuardado(calculo.id)}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );

  return (
    <section className="precio">
      <div className="precio__header">
        <h2>Calculadora de Precios {isV2 ? "(V2)" : ""}</h2>
        <p>
          Selecciona las características del producto para calcular su precio
          estimado
        </p>
        <div className="precio__header__actions">
          <Button
            variant={modoComparativa ? "filled" : "outlined"}
            label={modoComparativa ? "Modo Simple" : "Comparar"}
            icon={<HiOutlineScale />}
            onClick={() => setModoComparativa(!modoComparativa)}
          />
          <Button
            variant="outlined"
            label="Cálculos Guardados"
            icon={<HiOutlineBookmark />}
            onClick={() => setMostrarCalculosGuardados(true)}
            disabled={calculosGuardados.length === 0}
          />
        </div>
      </div>

      {modoComparativa ? (
        <div className="precio__comparativa">
          {renderFormulario(true, "Configuración A")}
          {renderFormulario(false, "Configuración B")}
        </div>
      ) : (
        renderFormulario(true)
      )}

    {/* {isV2 && <pre>{JSON.stringify(responseAverage, null, 2)}</pre>} */}

      <CalculosGuardadosModal />
      <Notification ref={notificationRef} />

      {renderValoracionPopup(true)}
      {renderValoracionPopup(false)}
    </section>
  );
}
